module.exports = __webpack_public_path__ + "static/img/icon_code.75504e6f.png";